import React from 'react';

import { FlatList, View } from 'react-native';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

function Section({
    title,
    data,
    renderItem,
    testID,
    ...flatListProps
}: {
    title: string;
    data: any;
    renderItem: any;
    testID?: string;
}) {
    return (
        <View style={styles.root}>
            <Text
                style={styles.text}
                category={ETextCategory.title3}
                color={ETextColor.neutral}
                accessibilityRole="header"
                testID={testID}
            >
                {title}
            </Text>
            <FlatList data={data} renderItem={renderItem} {...flatListProps} />
        </View>
    );
}

export default Section;
